import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { CompanyMetricsRecord } from 'src/models';
import { fetchMetricsAction } from 'src/services/companyMetrics';

const metricsEntityAdapter = createEntityAdapter({
  selectId: (metric: CompanyMetricsRecord) => metric.id,
});

export const metricsSelectors = metricsEntityAdapter.getSelectors();

const initialState: {
  isPending: boolean | null;
  hasError: boolean;
} = {
  isPending: null,
  hasError: false,
};

const metricsSlice = createSlice({
  name: 'companyMetrics',
  initialState: metricsEntityAdapter.getInitialState(initialState),
  reducers: {
    clearCompanyMetricsState: (state) => {
      state.isPending = null;
      state.hasError = false;
      metricsEntityAdapter.setAll(state, []);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchMetricsAction.pending, (state) => {
      state.isPending = true;
      state.hasError = false;
    });
    builder.addCase(fetchMetricsAction.fulfilled, (state, { payload }) => {
      metricsEntityAdapter.setAll(state, payload);
      state.isPending = false;
      state.hasError = false;
    });
    builder.addCase(fetchMetricsAction.rejected, (state) => {
      state.isPending = false;
      state.hasError = true;
    });
  },
});

export const { clearCompanyMetricsState } = metricsSlice.actions;

const { reducer } = metricsSlice;

export default reducer;
